import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export const setupSerwistUpdates = ({
  serwist,
  routerEvents,
  windowRef,
  applyWaitingImmediately = false
}) => {
  let waiting = false;
  let activationRequested = false;
  const onWaiting = () => {
    waiting = true;
    if (!applyWaitingImmediately) return;
    activationRequested = true;
    serwist.messageSkipWaiting();
  };
  const onControlling = event => {
    const reload = activationRequested || applyWaitingImmediately && event?.isUpdate;
    waiting = false;
    activationRequested = false;
    if (reload) windowRef.location.reload();
  };
  const onRouteComplete = (_url, {
    shallow
  } = {}) => {
    if (!waiting || shallow) return;
    activationRequested = true;
    serwist.messageSkipWaiting();
  };
  serwist.addEventListener("waiting", onWaiting);
  serwist.addEventListener("controlling", onControlling);
  routerEvents.on("routeChangeComplete", onRouteComplete);
  return () => {
    serwist.removeEventListener("waiting", onWaiting);
    serwist.removeEventListener("controlling", onControlling);
    routerEvents.off("routeChangeComplete", onRouteComplete);
  };
};

/** Register Serwist and apply a waiting worker at the configured update point. */
export default function useSerwistUpdate(t0) {
  const $ = _c(6);
  const {
    router,
    SerwistClass,
    scriptUrl,
    applyWaitingImmediately: t1
  } = t0;
  const applyWaitingImmediately = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== SerwistClass || $[1] !== applyWaitingImmediately || $[2] !== router.events || $[3] !== scriptUrl) {
    t2 = () => {
      if (process.env.NODE_ENV !== "production" || typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
        return;
      }
      if (!(window.serwist instanceof SerwistClass)) {
        window.serwist = new SerwistClass(scriptUrl, {
          scope: "/",
          updateViaCache: "none"
        });
      }
      const serwist = window.serwist;
      const cleanup = setupSerwistUpdates({
        serwist,
        routerEvents: router.events,
        windowRef: window,
        applyWaitingImmediately
      });
      serwist.register().catch(_temp);
      return () => {
        cleanup();
      };
    };
    t3 = [SerwistClass, scriptUrl, applyWaitingImmediately, router.events];
    $[0] = SerwistClass;
    $[1] = applyWaitingImmediately;
    $[2] = router.events;
    $[3] = scriptUrl;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
}
function _temp(error) {
  return console.error("Service worker registration failed:", error);
}